$('#modal-container').on('shown.bs.modal', function () {
  $(document).trigger('initialize-modal.custom');
})

$(document).bind('initialize-modal.custom', function () {
  $("form[data-behaviour~=modal_form]").on('submit', function (e) {
    var $this = $(this);
    e.stopImmediatePropagation();
    $.ajax(this.action, {
      type: 'POST',
      data: $this.serialize(),
      statusCode: {
        200: function (data, textStatus, jqXHR) {
          $('#modal-container').find('.modal-content').html(data);
          $(document).trigger('initialize-modal.custom');
        },
        202: function (data, textStatus, jqXHR) {
          var d = $.parseJSON(data);
          if (d.location) {
            document.location = d.location;
          } else {
            $('#modal-container').modal('hide');
          }
        }
      }
    });
    return false;
  });
});
